import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import { Menu, MenuList, MenuButton, MenuItem, MenuLink } from '@reach/menu-button';
import './style.scss';
import Logo from '../Logo';
import Icon from '../Icon';

const UserInfo = ({ logoutHandler, children }) => {
	return (
		<div className="mobile-header__user-info">
			<p className="mobile-header__user-text">{children}</p>
			<button title="Logout" onClick={() => logoutHandler()} className="material-icons logout-button">
				logout
			</button>
		</div>
	);
};

const MenuNavigationItem = ({ link, children }) => {
	return (
		<MenuLink as={NavLink} to={`/${link}`} className="mobile-header__navlink" activeClassName="mobile-header__navlink--active">
			{children}
		</MenuLink>
	);
};

const MobileNavigationBar = ({ userGroup, navItems, userName, logoutHandler }) => {
	return (
		<header className="mobile-header">
			<NavLink to="/" className="nav-item-logo">
				<Logo className="logo" />
			</NavLink>
			<div className="mobile-header__username-container">
				<div>{userName}</div>
				<Menu>
					<MenuButton className="mobile-header__menu-button">
						<Icon>menu</Icon>
					</MenuButton>
					<MenuList className="mobile-header__menu-list slide-down">
						{userGroup &&
							navItems.map((item, index) => (
								<MenuItem key={item.name + index} as={MenuNavigationItem} link={item.link}>
									{item.name}
								</MenuItem>
							))}
						<MenuItem>
							<UserInfo logoutHandler={logoutHandler}>Log out</UserInfo>
						</MenuItem>
					</MenuList>
				</Menu>
			</div>
		</header>
	);
};

MobileNavigationBar.propTypes = {
	userName: PropTypes.string,
	userGroup: PropTypes.array,
	navItems: PropTypes.array,
	logoutHandler: PropTypes.func
};

export default MobileNavigationBar;
